/**
 * Collapse a "Parent: Child" theme name to just "Parent" when both halves are
 * identical (the common case for a top-level theme with no distinct
 * subtheme). Pure and stateless — extracted from `useThemes` so cross-feature
 * consumers (a CSV export, say) can use it without pulling in the whole
 * `defaultFilterList`-backed hook.
 */
export const normalizeThemeName = (theme: string): string => {
  const parts = theme.split(': ')
  const parentTheme = parts[0] ?? theme
  const childTheme = parts[1]
  if (parentTheme === childTheme) {
    return parentTheme
  }
  return theme
}

/**
 * Split a stored theme value into its parent theme and subtheme.
 *
 * Clustering stores a theme whose parent and subtheme share a name as the
 * bare name ("Packaging"), not "Packaging: Packaging". A value with no
 * ": " delimiter is therefore that theme, with itself as the subtheme — never
 * a theme missing its subtheme.
 */
export const splitThemeName = (
  value: string,
): { theme: string; subtheme: string } => {
  const delimiterIndex = value.indexOf(': ')
  if (delimiterIndex === -1) {
    return { theme: value, subtheme: value }
  }
  return {
    theme: value.slice(0, delimiterIndex),
    subtheme: value.slice(delimiterIndex + 2),
  }
}
